{
  "moreInformation": {
    "heading": "Lisätietoja"
  },
  "calculationResult": {
    "error": {
      "heading": "Valitettavasti emme voi antaa arviota",
      "description": "Antamiesi tietojen perusteella emme voi antaa arviota siitä, kuinka paljon voisit saada lainaa. Ilmoittamasi tulot saattavat olla liian alhaiset, joten kokeile erilaisia lukuja."
    }
  }
}
